import React from 'react';

import { Box, TokenGroup } from '@amzn/awsui-components-react-v3';

import { AsyncState, Serial } from '../../store/types';
import { SerialToken } from './SerialToken';

import './scanSerials.scss';

export interface SerialTokensProps {
  serials?: Serial[];
  orderedSerials?: Serial[];
  onDelete: (s: Serial[]) => void;
  containerId: string;
  disabled?: boolean;
  onClickSerial: (s: Serial) => void;
  onsiteSpecificSerialScanned: (s: Serial, val: string) => void;
  receiveState: AsyncState;
}

const SerialTokens = ({
  orderedSerials = [],
  serials = [],
  onDelete,
  containerId,
  disabled = false,
  receiveState,
  onClickSerial,
  onsiteSpecificSerialScanned,
}: SerialTokensProps) => {
  return (
    <Box margin="s">
      <TokenGroup
        onDismiss={({ detail: { itemIndex } }) => {
          const token: Serial = orderedSerials[itemIndex];
          onDelete([token]);
        }}
        // TODO - type is set to string from TokenGroup, rendering the reactNode to string,
        items={orderedSerials?.map((token) => {
          return {
            label: (
              <SerialToken
                onClick={onClickSerial}
                key={containerId}
                token={token}
                receiveState={receiveState}
                serials={serials}
                containerId={containerId}
                disabled={disabled}
                onsiteSpecificSerialScanned={onsiteSpecificSerialScanned}
              />
            ),
            dismissLabel: `Remove serial ${token.serialNumber}`,
          };
        })}
      />
    </Box>
  );
};

export default SerialTokens;
